<form [formGroup]="form" class="row">
	<mat-form-field class="col">
		<mat-label>{{ matLabel }}</mat-label>
		<input matInput aria-label="Password" [type]="hide ? 'password' : 'text'" [placeholder]="placeholder"
			[name]="controlName" [formControlName]="controlName" [matAutocomplete]="auto" />
		<button type="button" mat-icon-button matSuffix (click)="toggleHide()" [attr.aria-label]="'Hide password'"
			[attr.aria-pressed]="hide" tabindex="-1">
			<mat-icon>{{hide ? "visibility_off" : "visibility"}}</mat-icon>
		</button>
	</mat-form-field>
	<mat-progress-bar class="progress-bar-position" [color]="progressColor" [mode]="'determinate'" [value]="progress">
	</mat-progress-bar>

	<mat-autocomplete #auto="matAutocomplete">
		<mat-option *ngFor="let option of filteredOptions | async" [value]="option.name"></mat-option>
	</mat-autocomplete>
</form>
<app-msg *ngIf="!isLoading && (msg && !msg.SUCCESS)" [msg]="msg"></app-msg>